import { WS_CONNECTED, WS_DISCONNECTED } from "./types";

export const wsConnected = () => ({ type: WS_CONNECTED });
export const wsDisconnected = () => ({ type: WS_DISCONNECTED });
